<script>
import Layout from "../../../layouts/manage";
// import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { invoiceService } from "../../../../services/managements/invoices/invoice.service";
import { invoiceStatusService } from "../../../../services/managements/invoices/invoicestatus.service";
import List from "../../../../components/list";
import Screen from "../../../../components/screen";
// import Fastview from "@/components/property-fastview";
import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Invoice List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    // PageHeader, 
    List, 
    // Fastview,
  },
  data() {
    return {
      ...Screen.Alert,
      ...Screen.Locate,
    
      fetchingStats: false,
      title: "Invoice List",


      propertyData: {},
      invoiceData: {},
      invoiceStatusData: {}

    };
  },
  mounted() {
    let hasId = 'id' in this.$route.params;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else {
      this.loadingData(0);     
    }

  },

  methods: {
    loadingData: function(id, param='') {
      let uri = '';
      if(id){
        uri = `&clause={"clause":[{"conjuction":"and","mg_invoices.property_id":{"value":${id}}}]}`;

      }
      param = param ? param + uri : `?page=1`+uri;
      this.fetchingStats = false;
      invoiceService.getList(param)
        .then(response => {
          this.fetchingStats = true;
          this.invoiceData = response;
          this.loadStatusData();
        });
    },

    loadStatusData: function(){
      let param = '?page=0';
      this.fetchingStats = false;
      invoiceStatusService.getList(param)
        .then(response => {
          this.fetchingStats = true;
          this.invoiceStatusData = response.data

        });
    },


    pageNavigate: function(param) {
      console.log(param);
      this.loadingData(this.$route.params.id, param);
    },

    moreClick: function(event, id) {
      if(event == 'unkeep') {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('property.unkeep-message'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {
            this.unKeepClick(id);
          }
        });
      }
    }

  }
};
</script>

<template>
  <Layout>
    <!-- <PageHeader
    :title="$t('menuitems.property.text')" /> -->
    <!-- <Fastview 
      id="fast-view"
      ref="fast-view"
      :title="viewTitle"
      :item="viewObject"
      :filters="$options.filters"
    />  -->
    <p class="khb h4">{{$t('invoice.text')}}</p>
    <div v-if="invoiceData">
      <List v-bind:dataList="invoiceData" 
          @more="moreClick"
          v-bind:more="{
            sub: [
            {name: 'manage.payment', icon:'bx bx-money', link: 'manage-invoice-payment', column: 'id', show: {column: 'status_id', value: 2}},
            {name: 'manage.payment', icon:'bx bx-money', link: 'manage-invoice-payment', column: 'id', show: {column: 'status_id', value: 3}},
            {name: 'invoice.print', icon:'bx bx-printer', link: 'manage-invoice-print', column: 'id'},
            {name: 'invoice.void', icon:'fas fa-times', link: 'manage-invoice-void', column: 'id', show: {column: 'is_void', value: 0}},
            
            ]
          }"
          v-bind:filter="{
            search: ['mg_invoices.code', 'customers.name', 'customers.name_en'],
            dropdown: [{
              title: 'property.status',
              field: 'mg_invoices.status_id',
              data: this.invoiceStatusData,
              width: 2
            }]
          }"
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[{name: 'code', type: 'fast-view'}, {name: 'invoice_date', type: 'date'}, {name: 'expired_date', type: 'date'}, {name: 'status', color: true}, {name:'total', type:'currency'}, {name:'amount_to_pay', type:'currency'}]"
          v-bind:fields="[ 
            `code: ${$t('payment.code')}`, 
            `invoice_date: ${$t('invoice.date')}`, 
            `expired_date: ${$t('booking.expired')}`, 
            `status: ${$t('invoice.status')}`, 
            `total: ${$t('invoice.total')}`,
            `penalty_amount: ${$t('manage.penalty-setting.penalty-amount')}`,
            `receive_amount: ${$t('manage.receive-amount')}`,
            `customer_name_en: ${$t('customer.text')}`,
            `service_for: ${'ចេញអោយ'}`
            ]"
        />
    </div>
  </Layout>
</template>